<div class="custom-header" (dblclick)="toggleGroup()">
    <span class="ag-group-expanded" [class.visible]="hasChildren" [class.invisible]="!hasChildren" *ngIf="isGroupCollapsed" (click)="this.toggleGroup()">
      <span class="ag-icon ag-icon-tree-closed">
      </span>
    </span>
    <span class="ag-group-contracted" [class.visible]="hasChildren" [class.invisible]="!hasChildren" *ngIf="!isGroupCollapsed"  (click)="this.toggleGroup()">
      <span class="ag-icon ag-icon-tree-open">
      </span>
    </span>
    <a class="group-name"
       title="{{ displayValue }}"
       (click)="onGroupNameClick($event)">{{ displayValue }} ({{params.data.trainingWeeks}} {{'plan.settings.weeks' | translate}})</a>
    <div class="action-buttons-container">
    <span class="action-buttons">
        <!-- <i class="icon icon-add" (click)="onAdd()" pTooltip="Add Class" tooltipPosition="left"></i> -->
        <button id="add-class"
        class="btn btn-secondary btn-small no-right-margin" (click)="onAdd($event)">{{'learning.curve.group.add.class.btn' | translate}}</button>
    </span>
    </div>
  </div>
